import { useCallback } from 'react';
import { useAppDispatch } from '../../../hooks';
import {
    setAudioItems,
    setLoading,
    setError
} from '../../../store/slices/audioSlice';
import log from 'loglevel';
import axios from 'axios';
import { apiService } from '../../../remote/apiService';

const useContentFetch = () => {
    const dispatch = useAppDispatch();

    /**
     * 开发环境的课程path是/public/course/courseId/lessonId/
     */
    const getHtmlContent = useCallback(async (courseId: string, lessonId: string) => {
        if (!courseId || !lessonId) return;

        dispatch(setLoading(true));
        dispatch(setError(null));
        try {
            
            const audioResponse = await apiService.getAudioUrls(courseId, lessonId);
            const audioUrlsMap = audioResponse.data.audioUrls;
            const htmlUrl = audioResponse.data.htmlUrl;
            
            log.debug("htmlUrl: ", htmlUrl);
            const response = await axios.get(htmlUrl);
            const htmlString = response.data;
            const doc = new DOMParser().parseFromString(htmlString, "text/html");

            const audioInfos = await Promise.all(
                Array.from(doc.querySelectorAll('.jk-en')).map(async (enElem, index) => {
                    const url = audioUrlsMap[index.toString()];
                    log.debug("audioUrl: ", url);
                    return {
                        en: enElem.textContent || '',
                        zh: enElem.nextElementSibling?.textContent || '',
                        audio: url || '',
                        id: enElem.id,
                    };
                })
            );

            dispatch(setAudioItems(audioInfos));
            
            return htmlString;
        } catch (e) {
            const errorMessage = e instanceof Error ? e.message : String(e);
            dispatch(setError(errorMessage));
        } finally {
            dispatch(setLoading(false));
        }
    }, [dispatch]);


    return { getHtmlContent };
};

export default useContentFetch;